import { render, staticRenderFns } from "./dialog_add_data_source.vue?vue&type=template&id=013b20db&scoped=true&lang=html"
import script from "./dialog_add_data_source.vue?vue&type=script&lang=js"
export * from "./dialog_add_data_source.vue?vue&type=script&lang=js"
import style0 from "./dialog_add_data_source.vue?vue&type=style&index=0&id=013b20db&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b20db",
  null
  
)

export default component.exports